function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Spicy (cold resist)");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "#93EBF1"
}, React.createElement("path", {
  d: "M13 25.86l-7 4H3l-2-1-1-2v-2l2-2 26-15h4l1 1 1 2v1l-1 2-20 12z"
}), React.createElement("path", {
  d: "M13.02 11.85l.13-8.06 1.02-1.72.51-.86L16.56 0l2.24.16 1.72 1.02.69 2.74-.13 8.06-.23 21.96-1.02 1.72-1.02 1.72-1.37.35-2.23-.17-.86-.51-1.21-1.88-.12-23.32z"
}), React.createElement("path", {
  d: "M10 19.86l-6-4-3-2-1-1v-3l2-2 2-1 2 1 2 1 3 2 5 3-6 6zM24 18.86v8h-1l-1-1h-2v-5l4-2z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M22 28.86l8 9h1l7-8v-1h-4v-9l-1-1h-6l-1 1v9h-4z"
})));

var SvgSpicy = function SvgSpicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 38 37.86",
    width: 30,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spicy.3f3eb5e1.svg";
export { ForwardRef as ReactComponent };